(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tdee-macro-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function roundTo(value, nearest) {
      return Math.round(value / nearest) * nearest;
    }
    function formatNumber(value) {
      return Number(value).toLocaleString('en-US');
    }
    function mifflinStJeor(input) {
      var base = 10 * input.weightKg + 6.25 * input.heightCm - 5 * input.age;
      return input.sex === 'male' ? base + 5 : base - 161;
    }
    function calculateTargets(config, input) {
      var bmr = mifflinStJeor(input);
      var factor = Number(config.activityFactors[input.activity]) || 1.2;
      var tdee = bmr * factor;
      var maintenance = roundTo(tdee, config.calorieRoundTo);
      var percent = Number(config.goalCaloriePercent[input.goal]);
      if (!isFinite(percent)) percent = 0;
      var target = roundTo(tdee * (1 + percent / 100), config.calorieRoundTo);
      var proteinG = Math.min(Math.round(input.weightKg * config.proteinPerKg[input.goal]), config.proteinCapG);
      var fatG = Math.round((target * config.fatCaloriePercent) / config.kcalPerGramFat);
      var remaining = target - proteinG * config.kcalPerGramProtein - fatG * config.kcalPerGramFat;
      var carbsG = Math.max(0, Math.round(remaining / config.kcalPerGramCarb));
      return { maintenance: maintenance, target: target, proteinG: proteinG, fatG: fatG, carbsG: carbsG };
    }
    function selectedValue(root, field) {
      var el = root.querySelector('[data-mp-field="' + field + '"]:checked');
      return el ? el.value : null;
    }
    function setError(root, name, message) {
      var el = root.querySelector('[data-mp-error="' + name + '"]');
      if (!el) return;
      if (message) {
        el.hidden = false;
        el.textContent = message;
      } else {
        el.hidden = true;
        el.textContent = '';
      }
    }
    function validateNumber(root, config, messages, name) {
      var input = root.querySelector('[data-mp-input="' + name + '"]');
      var raw = input.value.trim();
      var range = config.validation[name];
      input.classList.remove('is-invalid');
      if (raw === '') {
        setError(root, name, messages[name]);
        input.classList.add('is-invalid');
        return null;
      }
      var value = Number(raw);
      if (!isFinite(value)) {
        setError(root, name, messages[name]);
        input.classList.add('is-invalid');
        return null;
      }
      if (name === 'age' && Math.floor(value) !== value) {
        setError(root, name, messages.ageWhole);
        input.classList.add('is-invalid');
        return null;
      }
      if (value < range.min || value > range.max) {
        setError(root, name, messages.range.replace('{min}', range.min).replace('{max}', range.max));
        input.classList.add('is-invalid');
        return null;
      }
      setError(root, name, '');
      return value;
    }
    function init(root) {
      if (root.dataset.mpReady === '1') return;
      root.dataset.mpReady = '1';
      var configEl = root.querySelector('[data-mp-tdee-config]');
      var config = JSON.parse(configEl.textContent);
      var form = root.querySelector('[data-mp-form]');
      var results = root.querySelector('[data-mp-results]');
      var messages = config.messages;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var ok = true;
        var goal = selectedValue(root, 'goal');
        var sex = selectedValue(root, 'sex');
        var activity = selectedValue(root, 'activity');
        if (!goal) {
          setError(root, 'goal', messages.goal);
          ok = false;
        } else setError(root, 'goal', '');
        if (!sex) {
          setError(root, 'sex', messages.sex);
          ok = false;
        } else setError(root, 'sex', '');
        var age = validateNumber(root, config, messages, 'age');
        var height = validateNumber(root, config, messages, 'height');
        var weight = validateNumber(root, config, messages, 'weight');
        if (age === null || height === null || weight === null) ok = false;
        if (!activity) {
          setError(root, 'activity', messages.activity);
          ok = false;
        } else setError(root, 'activity', '');
        if (!ok) {
          var first = root.querySelector('.mp-tdee__error:not([hidden]), .is-invalid');
          if (first) first.scrollIntoView({ block: 'center' });
          return;
        }
        var result = calculateTargets(config, {
          sex: sex,
          age: age,
          weightKg: weight,
          heightCm: height,
          activity: activity,
          goal: goal,
        });
        root.querySelector('[data-mp-kcal]').textContent = formatNumber(result.target);
        root.querySelector('[data-mp-protein]').textContent = formatNumber(result.proteinG);
        root.querySelector('[data-mp-carbs]').textContent = formatNumber(result.carbsG);
        root.querySelector('[data-mp-fat]').textContent = formatNumber(result.fatG);
        root.querySelector('[data-mp-tdee-value]').textContent = formatNumber(result.maintenance);
        results.hidden = false;
        results.scrollIntoView({ block: 'start' });
      });
    }
    function initAll() {
      document.querySelectorAll('[data-mp-tdee]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-mp-tdee]');
      if (root) {
        root.dataset.mpReady = '';
        init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
